var map = {
	"./01car.svg": 37721,
	"./14excavator.svg": 71810,
	"./arrow.svg": 82363,
	"./bicycle.svg": 59643,
	"./bus.svg": 90082,
	"./businesscar.svg": 85276,
	"./car.svg": 41986,
	"./excavator.svg": 61791,
	"./excavator2.svg": 51023,
	"./logo.svg": 92957,
	"./motorbike.svg": 42492,
	"./motorcycle.svg": 97311,
	"./plain.svg": 37916,
	"./ship.svg": 25918,
	"./suv.svg": 19738,
	"./trackplayback.svg": 59462,
	"./transportmixer.svg": 78718,
	"./truck.svg": 99961,
	"./untitled.svg": 74647,
	"./van.svg": 54967,
	"./videomonitor.svg": 2873,
	"./videoplayback.svg": 73530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;